import { Badge, Carousel, Col, ProgressBar, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageLayout from "../layouts/PageLayout";
import { useState } from "react";
import {
  FaUser,
  FaAddressCard,
  FaPhoneAlt,
  FaPencilAlt,
  FaDollarSign,
  FaCalendarCheck,
  FaCity,
  FaFlag,
  FaBullseye,
  FaHeartbeat,
  FaSchool,
} from "react-icons/fa";
import { TbGenderEpicene } from "react-icons/tb";
import { MdFamilyRestroom } from "react-icons/md";
import {
  MdFormatListNumbered,
  MdSchool,
  MdModelTraining,
} from "react-icons/md";
import { SiRescuetime } from "react-icons/si";
import { GiSlaveryWhip } from "react-icons/gi";
import { FaFileWaveform, FaArrowRightToCity, FaPerson } from "react-icons/fa6";
import { TbStatusChange } from "react-icons/tb";
import { SlCalender } from "react-icons/sl";
import { GiThreeLeaves } from "react-icons/gi";
import { BsBank2, BsCapsule } from "react-icons/bs";
import card_front from "../assets/images/card front.jpeg";
import { DivideTitleComponent } from "../components";

export default function CompleteFamilyProfile() {
  const [formState, setFormState] = useState({
    profile_pic: { file: null, preview: null },
  });
  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                <i className="material-icons">factory</i>
                Complete Family Profile
              </h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="/" className="mc-breadcrumb-link">
                    Home
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">Acitivity Timeline</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        {/* PROFILE CARD */}
        <div className="mc-card" style={{ width: "100%", display: "flex" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "30%",
            }}
          >
            <img
              style={{ borderRadius: "50%" }}
              src="https://thumbs.dreamstime.com/b/profile-picture-caucasian-male-employee-posing-office-happy-young-worker-look-camera-workplace-headshot-portrait-smiling-190186649.jpg"
              width={150}
              height={150}
              alt="Profile Pic"
            />
            <div
              style={{
                color: "black",
                fontWeight: "bold",
                fontSize: "15px",
                marginTop: "7px",
              }}
            >
              GHAFOOR MASIH
            </div>
            <div style={{ fontSize: "10px" }}>FSF-1364</div>
          </div>

          <div style={{ display: "flex" }} id="details">
            <div>
              <ul style={{ marginTop: "30px" }}>
                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaUser style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Data Entered By:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Inshal Johnson
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <TbGenderEpicene style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Gender:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Male
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <MdFamilyRestroom style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Martial Status:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Married
                    </span>
                  </span>
                </li>

                <li>
                  <i>
                    {" "}
                    <MdFormatListNumbered style={{ color: "black" }} />
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Age:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      58 Years
                    </span>
                  </span>
                </li>
              </ul>
            </div>

            <div>
              <ul style={{ marginTop: "30px", marginLeft: "50px" }}>
                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <SiRescuetime style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Rescued By:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Sharoon Sarfaraz
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <GiSlaveryWhip style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Slavery Years:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      10 Years
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaFileWaveform style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Undertaking Form:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>N/A</span>
                  </span>
                </li>

                <li>
                  <i>
                    {" "}
                    <TbStatusChange style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Status:{" "}
                    <span style={{ fontSize: "12px" }}>
                      <Badge bg="primary"> On-Going</Badge>
                    </span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* MORE DETAILS */}
        <div
          className="mc-card"
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
        >
          <h3 style={{ marginBottom: "10px" }}>MORE DETAILS</h3>

          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "33.34%",
              }}
            >
              <ul>
                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <SlCalender style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Rescued Date:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      29-08-2024
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaPhoneAlt style={{ color: "black" }} />
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Cell:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      0323-3434343
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <GiThreeLeaves style={{ color: "black" }} />
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Occupation:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      NULL
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaPencilAlt style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Baptized:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>Yes</span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaDollarSign style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Family Donor:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Families
                    </span>
                  </span>
                </li>
              </ul>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "33.34%",
              }}
            >
              <ul>
                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <SlCalender style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Entry Date:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      30-08-2024
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaAddressCard style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    CNIC:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      35202-3402434-1
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <BsBank2 style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    religion:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Islam
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <BsCapsule style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Slavery Reason:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Poverty
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaDollarSign style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Buisness Donor:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Families
                    </span>
                  </span>
                </li>
              </ul>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                width: "33.34%",
              }}
            >
              <ul>
                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaCalendarCheck style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Family Slavery Years:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      10 Years
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaCity style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Province:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Punjab
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaArrowRightToCity style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    City:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Lahore
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaFlag style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Flagged:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>Yes</span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaBullseye style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Abused:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>Yes</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* PROGRESS REPORT */}
        <div className="mc-card" style={{ width: "100%", marginLeft: "15px" }}>
          <div style={{ color: "black", fontWeight: "bold" }}>
            STATUS:
            <span>
              <Badge bg="primary" style={{ marginLeft: "7px" }}>
                ON-GOING
              </Badge>
            </span>
          </div>

          <div
            style={{ fontWeight: "bold", color: "black", marginTop: "10px" }}
          >
            PROGRESS REPORT:
            <ul
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <li style={{ marginRight: "5px" }}>
                <Badge bg="success">FOLLOW-UP</Badge>
              </li>
              <li style={{ marginRight: "5px" }}>
                <Badge bg="success">FAMILY</Badge>
              </li>
              <li style={{ marginRight: "5px" }}>
                <Badge bg="success">STORY</Badge>
              </li>
              <li style={{ marginRight: "5px" }}>
                <Badge bg="success">BUSINESS</Badge>
              </li>
              <li style={{ marginRight: "5px" }}>
                <Badge bg="danger">LOAN</Badge>
              </li>
            </ul>
          </div>

          <div style={{ marginTop: "20px" }}>
            <ProgressBar now={60} label={"60%"} />
          </div>
        </div>

        {/* CNIC */}
        <div
          className="mc-card"
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
        >
          <h3 style={{ marginBottom: "10px" }}>CNIC:</h3>

          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "50%",
              }}
            >
              <div
                style={{
                  width: "99.5%",
                  height: "200px",
                  border: "dashed",
                  borderRadius: "10px",
                  borderColor: "blue",
                  position: "relative",
                }}
              >
                <i
                  style={{
                    color: "blue",
                    position: "absolute",
                    left: "40%",
                    top: "10%",
                    fontSize: "100px",
                  }}
                >
                  <FaAddressCard />
                </i>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "50%",
              }}
            >
              <div
                style={{
                  width: "99.5%",
                  height: "200px",
                  border: "dashed",
                  borderRadius: "10px",
                  borderColor: "blue",
                  position: "relative",
                }}
              >
                <i
                  style={{
                    color: "blue",
                    position: "absolute",
                    left: "40%",
                    top: "10%",
                    fontSize: "100px",
                  }}
                >
                  <FaAddressCard />
                </i>
              </div>
            </div>
          </div>
        </div>

        {/* FAMILY TESTIMONY VIDEO */}
        <div
          className="mc-card"
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h3 style={{ marginBottom: "10px" }}>Family Testimony Video:</h3>
          <span
            style={{
              width: "100%",
              textAlign: "center",
              borderStyle: "dashed",
              borderColor: "blue",
              borderRadius: "10px",
              height: "200px",
              marginTop: "5px",
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            className="text-danger"
          >
            Video not Available!
          </span>
        </div>

        {/* FAMILY STORY */}
        <div className="mc-card">
          <h3 style={{ marginBottom: "10px" }}>Family Story:</h3>
          <hr />
          <span style={{}}>*Family story comes here*</span>
        </div>

        {/* IMAGE GALLERY */}
        <div className="mc-card">
          <h3 style={{ marginBottom: "15px" }}>Image Gallery</h3>
          <Carousel
            style={{
              height: "300px",
            }}
          >
            <Carousel.Item>
              <img
                style={{ borderRadius: "10px" }}
                src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAJQA2wMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAABAAIDBv/EABwQAQEBAAMBAQEAAAAAAAAAAAABESExQQISUf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwD1E+Wvxrf5QMyYvy0QYsUh+qoAwwrAQhQIEAF8mgFe2eWgCSQIqoEpUqCqC0CDwgFDTIOtUKgKrFwoDOLDUAIUAhIAcSBYy0rAZFawWAoqsXNA4okCkFhQMrDZiAL1ICsQB1RoAGKqcUBYGlgMldKAkUAS3FAXgrQoMxFUGSV2ATWDOQQpABEUAiKBBgB1SUAekXWpOACI9BWCGoD4EgZpiMgIUgAK1gsARqdsmA1QfACxn01UAsMALBmnlXQGHBq0HUFZyAKQJU0eACkC8DUQMemHhQB6LG6AYMVMBm9KFAkhgJJAgRaBFSoA6pP6OAdsBqmgIVCABQDViQHENOgKYDAVFPKBkWFAMWNYICBsWAAVgBmxtUBIPWhwCrLQwHYHFn8AYViBejDhkBlFWAyjEAq1EB6UrAZKw4ABxYCSQBEYCgw4gCKgAEYDtYpDapQGHFpBmxNAGWuwoCs4ZxsAMOKmAyVioBJAgRgBFYARwYCSxALFJhQAGwA7fSjVigMlYcAYlizkFkFawYAnZUi/ILEOj2CVGYYDNOK9qAKGqMBYDkWAEcQBmxoWApOEkCRxnAd4qkAhSAJICKkAKQD6ESA1lIDFUgSiQL0hAFEgHrXiQAFAAkD/2Q=="
                width="100%"
                height="300px"
              ></img>
            </Carousel.Item>

            <Carousel.Item>
              <img
                style={{ borderRadius: "10px" }}
                src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAJQA2wMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAABAAIDBv/EABwQAQEBAAMBAQEAAAAAAAAAAAABESExQQISUf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwD1E+Wvxrf5QMyYvy0QYsUh+qoAwwrAQhQIEAF8mgFe2eWgCSQIqoEpUqCqC0CDwgFDTIOtUKgKrFwoDOLDUAIUAhIAcSBYy0rAZFawWAoqsXNA4okCkFhQMrDZiAL1ICsQB1RoAGKqcUBYGlgMldKAkUAS3FAXgrQoMxFUGSV2ATWDOQQpABEUAiKBBgB1SUAekXWpOACI9BWCGoD4EgZpiMgIUgAK1gsARqdsmA1QfACxn01UAsMALBmnlXQGHBq0HUFZyAKQJU0eACkC8DUQMemHhQB6LG6AYMVMBm9KFAkhgJJAgRaBFSoA6pP6OAdsBqmgIVCABQDViQHENOgKYDAVFPKBkWFAMWNYICBsWAAVgBmxtUBIPWhwCrLQwHYHFn8AYViBejDhkBlFWAyjEAq1EB6UrAZKw4ABxYCSQBEYCgw4gCKgAEYDtYpDapQGHFpBmxNAGWuwoCs4ZxsAMOKmAyVioBJAgRgBFYARwYCSxALFJhQAGwA7fSjVigMlYcAYlizkFkFawYAnZUi/ILEOj2CVGYYDNOK9qAKGqMBYDkWAEcQBmxoWApOEkCRxnAd4qkAhSAJICKkAKQD6ESA1lIDFUgSiQL0hAFEgHrXiQAFAAkD/2Q=="
                width="100%"
                height="300px"
              ></img>
            </Carousel.Item>

            <Carousel.Item>
              <img
                style={{ borderRadius: "10px" }}
                src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAJQA2wMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAABAAIDBv/EABwQAQEBAAMBAQEAAAAAAAAAAAABESExQQISUf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwD1E+Wvxrf5QMyYvy0QYsUh+qoAwwrAQhQIEAF8mgFe2eWgCSQIqoEpUqCqC0CDwgFDTIOtUKgKrFwoDOLDUAIUAhIAcSBYy0rAZFawWAoqsXNA4okCkFhQMrDZiAL1ICsQB1RoAGKqcUBYGlgMldKAkUAS3FAXgrQoMxFUGSV2ATWDOQQpABEUAiKBBgB1SUAekXWpOACI9BWCGoD4EgZpiMgIUgAK1gsARqdsmA1QfACxn01UAsMALBmnlXQGHBq0HUFZyAKQJU0eACkC8DUQMemHhQB6LG6AYMVMBm9KFAkhgJJAgRaBFSoA6pP6OAdsBqmgIVCABQDViQHENOgKYDAVFPKBkWFAMWNYICBsWAAVgBmxtUBIPWhwCrLQwHYHFn8AYViBejDhkBlFWAyjEAq1EB6UrAZKw4ABxYCSQBEYCgw4gCKgAEYDtYpDapQGHFpBmxNAGWuwoCs4ZxsAMOKmAyVioBJAgRgBFYARwYCSxALFJhQAGwA7fSjVigMlYcAYlizkFkFawYAnZUi/ILEOj2CVGYYDNOK9qAKGqMBYDkWAEcQBmxoWApOEkCRxnAd4qkAhSAJICKkAKQD6ESA1lIDFUgSiQL0hAFEgHrXiQAFAAkD/2Q=="
                width="100%"
                height="300px"
              ></img>
            </Carousel.Item>
          </Carousel>
        </div>

        {/* PRESENT RESIDENSE PIC */}
        <div style={{ width: "47%", marginLeft: "15px" }} className="mc-card">
          <div style={{ marginRight: "15px" }}>
            <h3>Present Address/Residense</h3>
            <p>*Present residense will come here*</p>
          </div>
        </div>

        {/* PERMANANT RESIDENSE PIC */}
        <div style={{ width: "47%", marginLeft: "15px" }} className="mc-card">
          <h3>Permanent Address</h3>
          <p>*Permanant Residense will come here*</p>
        </div>

        {/* FAMILY RELEASE IMAGE */}
        <div className="mc-card" style={{ width: "47%", marginLeft: "15px" }}>
          <h3>Family Release Image</h3>
        </div>

        {/* FAMILY NEW HOME IMAGE */}
        <div className="mc-card" style={{ width: "47%", marginLeft: "15px" }}>
          <h3>Family New Home Image</h3>
        </div>

        {/* PRAYER REQUEST */}
        <div className="mc-card">
          <h3>Family Prayer Request</h3>
          <hr />
          <ul>
            <li>*Prayer will come Here*</li>
            <li>*Prayer will come Here*</li>
            <li>*Prayer will come Here*</li>
            <li>*Prayer will come Here*</li>
            <li>*Prayer will come Here*</li>
          </ul>
        </div>

        {/* FAMILY MEMBER'S DETAILS */}
        <div className="mc-card">
          <h3>Family Members</h3>
          <hr />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>
              <ul>
                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaPerson style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Father's Name:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Dummy Name
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <SlCalender style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Slavery Years:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      34 Years
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <SlCalender style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Age:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      45 Years
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <TbGenderEpicene style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Gender:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Male
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaHeartbeat style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Alive:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>No</span>
                  </span>
                </li>
              </ul>
            </div>

            <div>
              <ul>
                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaPerson style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Mother's Name:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Dummy Name
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <SlCalender style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Slavery Years:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      34 Years
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <SlCalender style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Age:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      45 Years
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <TbGenderEpicene style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Gender:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Female
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaHeartbeat style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Alive:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>No</span>
                  </span>
                </li>
              </ul>
            </div>

            <div>
              <ul>
                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaPerson style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Spouse's Name:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Dummy Name
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <SlCalender style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Slavery Years:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      34 Years
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <SlCalender style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Age:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      45 Years
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <TbGenderEpicene style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Gender:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>
                      Male
                    </span>
                  </span>
                </li>

                <li style={{ paddingBottom: "10px" }}>
                  <i>
                    {" "}
                    <FaHeartbeat style={{ color: "black" }} />{" "}
                  </i>
                  <span style={{ color: "black", fontWeight: "bold" }}>
                    Alive:{" "}
                    <span style={{ color: "gray", fontSize: "12px" }}>No</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* CHILDREN DETAILS */}
        <div className="mc-card">
          <h3>Children Details (1)</h3>
          <table className="mc-table product">
            <thead className="mc-table-head primary">
              <tr
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <th>
                  <i style={{ color: "white", marginRight: "5px" }}>
                    <FaUser />
                  </i>
                  <span>Name</span>
                </th>

                <th>
                  <i style={{ color: "white", marginRight: "5px" }}>
                    <SlCalender />
                  </i>
                  <span>Age</span>
                </th>

                <th>
                  <i style={{ color: "white", marginRight: "5px" }}>
                    <SlCalender />
                  </i>
                  <span>Slavery Years</span>
                </th>

                <th>
                  <i style={{ color: "white", marginRight: "5px" }}>
                    <MdSchool />
                  </i>
                  <span>School Going</span>
                </th>

                <th>
                  <i style={{ color: "white", marginRight: "5px" }}>
                    <FaSchool />
                  </i>
                  <span>School Image</span>
                </th>

                <th>
                  <i style={{ color: "white", marginRight: "5px" }}>
                    <MdModelTraining />
                  </i>
                  <span>Training</span>
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </Row>
    </PageLayout>
  );
}
